module.exports = __webpack_public_path__ + "img/image4 copy.80f290bf.jpg";